import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/light-theme.css";
import "leaflet/dist/leaflet.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";
import { GlobalErrorBoundary } from "@/components/GlobalErrorBoundary";

initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);

// Sprint G · Service Worker para Push Notifications.
// Registro idempotente. Si el SW ya existe el navegador no lo vuelve a instalar.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* SW opcional · si falla, el resto de la app sigue funcionando */
    });
  });
}
